import React from 'react';

const TypingIndicator = () => (
  <div className="flex items-center gap-1 rounded-lg border border-white/10 bg-white/10 px-3 py-2 text-purple-100 backdrop-blur-lg" aria-label="Coach is typing">
    <span className="h-2 w-2 animate-pulse rounded-full bg-fuchsia-300" />
    <span className="h-2 w-2 animate-pulse rounded-full bg-pink-300 delay-100" />
    <span className="h-2 w-2 animate-pulse rounded-full bg-purple-300 delay-200" />
  </div>
);

export default TypingIndicator;
